import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { PageHeader } from "@/components/PageHeader";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { BookOpen, FileDown, Loader2, ShieldCheck, Store, GraduationCap } from "lucide-react";

const ICONOS = { admin: ShieldCheck, franquiciado: Store, profesor: GraduationCap };

export default function Manuales() {
  const [manuales, setManuales] = useState([]);
  const [bajando, setBajando] = useState(null);

  useEffect(() => {
    api.get("/manuales").then(({ data }) => setManuales(data)).catch(() => {});
  }, []);

  const descargar = async (rol) => {
    setBajando(rol);
    try {
      const { data } = await api.get(`/manuales/${rol}.pdf`, { responseType: "blob" });
      const url = URL.createObjectURL(data);
      const a = document.createElement("a");
      a.href = url;
      a.download = `manual-${rol}-bspark.pdf`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
    } catch (e) {
      toast.error("No se pudo descargar el manual");
    } finally {
      setBajando(null);
    }
  };

  return (
    <div data-testid="manuales-page">
      <PageHeader title="Manuales de uso"
        subtitle="Guías cortas y visuales para el equipo. Descárgalas en PDF y compártelas." />
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
        {manuales.map((m) => {
          const Icono = ICONOS[m.rol] || BookOpen;
          return (
            <Card key={m.rol} className="rounded-2xl p-6 border-border shadow-sm hover:shadow-md transition-shadow duration-200"
              data-testid={`manual-card-${m.rol}`}>
              <span className="h-12 w-12 rounded-full bg-accent flex items-center justify-center mb-4">
                <Icono className="h-6 w-6 text-primary" />
              </span>
              <h3 className="font-display text-lg font-bold">{m.titulo}</h3>
              <p className="text-sm text-muted-foreground mt-2">{m.resumen}</p>
              <p className="text-xs text-muted-foreground mt-3">{m.secciones} secciones · PDF</p>
              <Button className="rounded-full font-semibold w-full mt-5" disabled={bajando === m.rol}
                onClick={() => descargar(m.rol)} data-testid={`descargar-manual-${m.rol}`}>
                {bajando === m.rol ? <Loader2 className="h-4 w-4 animate-spin" />
                  : <><FileDown className="h-4 w-4 mr-2" /> Descargar PDF</>}
              </Button>
            </Card>
          );
        })}
        {manuales.length === 0 && (
          <p className="text-sm text-muted-foreground" data-testid="manuales-empty">
            Cargando manuales…
          </p>
        )}
      </div>
    </div>
  );
}
